import { ProjectStatus, VendorStatus } from '@sib/api';
import { getProjectStatusColor } from '../projects/project-status-styles';

const vendorStatusProjectColorToken: Record<VendorStatus, ProjectStatus> = {
  [VendorStatus.Active]: ProjectStatus.Completed,
  [VendorStatus.Inactive]: ProjectStatus.Unassigned,
  [VendorStatus.OnHold]: ProjectStatus.OnHold,
};

export const getVendorStatusColor = (
  status: VendorStatus = VendorStatus.Active
) =>
  getProjectStatusColor(
    vendorStatusProjectColorToken[status] ??
      vendorStatusProjectColorToken[VendorStatus.Active]
  );
